(function () {
  function sameHostReferrer() {
    try {
      if (!document.referrer) return false;
      return new URL(document.referrer).hostname === window.location.hostname;
    } catch (e) {
      return false;
    }
  }

  function normalizePath(url) {
    try {
      const u = new URL(url, window.location.origin);
      return u.pathname.replace(/\/+$/, '') || '/';
    } catch (e) {
      return (url || '').replace(/\/+$/, '') || '/';
    }
  }

  function findPath(links, targetPath, acc) {
    acc = acc || [];
    if (!Array.isArray(links)) return null;

    for (const link of links) {
      const node = { title: link.title, url: link.url };
      const nextAcc = acc.concat([node]);

      if (normalizePath(link.url) === targetPath) return nextAcc;

      if (link.links && link.links.length) {
        const child = findPath(link.links, targetPath, nextAcc);
        if (child) return child;
      }
    }
    return null;
  }

  function saveCrumbsForCurrentCollection() {
    const menu = window.BREADCRUMB_MENU;
    if (!menu) return;

    const path = normalizePath(window.location.pathname);

    // Alleen op collection pages
    if (!path.startsWith('/collections/')) return;

    const trail = findPath(menu, path, []);
    if (!trail || !trail.length) return;

    localStorage.setItem('breadcrumbs', JSON.stringify({ trail }));
  }

  function renderProductBreadcrumbs() {
    const wrapper = document.getElementById('breadcrumb-collection-wrapper');
    if (!wrapper) return;

 // Alleen breadcrumbs gebruiken als je van een collectiepagina komt.
// Via search, homepage, direct: reset zodat fallback gebruikt wordt.
let refPath = '';
try {
  refPath = document.referrer ? new URL(document.referrer).pathname : '';
} catch (e) {
  refPath = '';
}

if (!refPath.startsWith('/collections/')) {
  localStorage.removeItem('breadcrumbs');
  return;
}

    let data = null;
    try {
      data = JSON.parse(localStorage.getItem('breadcrumbs') || 'null');
    } catch (e) {}

    if (!data || !Array.isArray(data.trail) || !data.trail.length) return;

    let html = '';
    for (let i = 0; i < data.trail.length; i++) {
      const item = data.trail[i];
      const levelClass =
        i === 0 ? 'breadcrumbs-collection--main'
        : i === 1 ? 'breadcrumbs-collection--sub'
        : 'breadcrumbs-collection--subsub';

      html += `<span class="breadcrumbs-sep" aria-hidden="true">›</span>
        <div class="breadcrumbs-collection ${levelClass}">
          <a href="${item.url}">${item.title}</a>
        </div>`;
    }

    wrapper.innerHTML = html;
  }

  document.addEventListener('DOMContentLoaded', function () {
    saveCrumbsForCurrentCollection();
    renderProductBreadcrumbs();
  });
})();
